import { WorkoutCompletionStatus as e } from "./enum/workout-completion-status.enum.js";
class n {
  static getCompletionStatus(t) {
    return t.finishedAt ? e.FINISHED : t.startedAt ? e.STARTED : e.PLANNED;
  }
  /**
   * Get the appropriate navigation path for a workout based on its completion status
   * - Started workouts → progress page
   * - Planned/finished workouts → detail page
   */
  static getNavigationPath(t) {
    if (!t.niceId)
      throw new Error("Workout must have a niceId to generate navigation path");
    return this.getCompletionStatus(t) === e.STARTED ? `/workouts/${t.niceId}/progress` : `/workouts/${t.niceId}`;
  }
}
export {
  n as WorkoutUtils
};
